<template>

  <section class="panel-fact">
    <div class="row fact align-items-center">
        <div class="col-md-12 col-lg-3">
            <i :class="iconeFact" aria-hidden="true"></i>
        </div>
        <div class="col-md-12 col-lg-9">
            <h3 v-html="titreFact"></h3>
            <p v-html="messageFact"> </p>
        </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'panel-fact',
    props: [
      'titreFact',
      'messageFact',
      'iconeFact'
    ],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

